import { createBridgeMcpToolRegistry } from '../bridge-mcp-tools.js';
import type { BridgeMcpToolRegistry } from '../bridge-mcp-tool-types.js';
import type { CliE2eeRuntime } from '../../lib/e2ee/index.js';
import { startBridgeAccessServer } from './start-server.js';

export type BridgeAccessStateOptions = {
  cloudApiBaseUrl?: string;
  getCloudAccessToken?: () => string;
  e2ee?: CliE2eeRuntime;
};

export type BridgeAccessState = {
  getPort: () => number;
  getRegistry: () => BridgeMcpToolRegistry;
  close: () => Promise<void>;
};

export async function createBridgeAccessState(options: BridgeAccessStateOptions = {}): Promise<BridgeAccessState> {
  const registry = createBridgeMcpToolRegistry({
    cloudApiBaseUrl: options.cloudApiBaseUrl,
    getCloudAccessToken: options.getCloudAccessToken,
    e2ee: options.e2ee,
  });

  const server = await startBridgeAccessServer(registry);

  return {
    getPort: () => server.port,
    getRegistry: () => registry,
    close: async () => {
      await server.close();
    },
  };
}
